import { css } from '@emotion/react';
import { getScreen } from '@/styles/media-query';
import { News } from '@/types/cms-types';
import { withPrefix } from 'gatsby';

export type NewsPageTitleProps = {
  className?: string;
  title: News['title'];
  coverImage: News['coverImage'];
};

export const NewsPageTitle: React.FC<NewsPageTitleProps> = ({
  className,
  title,
  coverImage,
}) => {
  return (
    <header
      className={className}
      css={css`
        padding: 32px 0 0;
        position: relative;
        z-index: 1;

        @media ${getScreen('pc')} {
          padding: 165px 0 0;
        }
      `}
    >
      {/* 背景装飾・丸み */}
      <div
        css={css`
          pointer-events: none;
          position: absolute;
          z-index: -1;
          top: 0;
          left: 0;
          width: 100%;
          height: calc(100% - 64px);
          background: linear-gradient(
            257deg,
            #f0fcfb 0%,
            #f8fffe 49%,
            #ffffff 100%
          );
          mix-blend-mode: multiply;
          mask: url(${withPrefix('/images/section-round-reverse-sp.png')}) center bottom/100%
              64px no-repeat,
            linear-gradient(0deg, #000 0%, #000 100%) center bottom 63px/100%
              100% no-repeat;

          @media ${getScreen('pc')} {
            background: linear-gradient(
              264deg,
              #f0fcfb 0%,
              #f8fffe 49%,
              #ffffff 100%
            );
            mask: url(${withPrefix('/images/section-round-reverse-pc.png')}) center bottom/100%
                192px no-repeat,
              linear-gradient(0deg, #000 0%, #000 100%) center bottom 191px/100%
                100% no-repeat;
          }
        `}
      />
      <div
        css={css`
          width: 574px;
          height: 300px;
          height: auto;
          margin: 0 auto;
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0px 0px 16px #0e3e8129;

          @media ${getScreen('pc', '未満')} {
            max-width: 315px;
          }
        `}
      >
        <Image
          css={css`
            width: 100%;
            height: 100%;
            object-fit: cover;
          `}
          coverImage={coverImage}
          alt={title}
        />
      </div>
    </header>
  );
};

const Image: React.FC<{
  className?: string;
  coverImage?: News['coverImage'];
  alt?: string;
}> = ({ className, coverImage, alt = '' }) => {
  return coverImage ? (
    <img
      className={className}
      src={`${coverImage.url}?fm=webp&w=574`}
      width={coverImage.width}
      height={coverImage.height}
      alt={alt}
    />
  ) : (
    <img
      className={className}
      src={withPrefix('/ogp.png')}
      width={574}
      height={300}
      alt={alt}
    />
  );
};
